import React from "react";

const Turbolink = (props) => {
  const onClick = (e) => {
    e.preventDefault();
    Turbo.visit(props.href);
  };

  return <a {...props} onClick={onClick} />;
};

export default Turbolink;
